import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-token-expired-dialog',
  templateUrl: './token-expired-dialog.component.html',
  styleUrl: './token-expired-dialog.component.scss',
})
export class TokenExpiredDialogComponent {
  countdown: number = 5; // Set the countdown time in seconds
  interval: any;
  constructor(
    public dialogRef: MatDialogRef<TokenExpiredDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}
  ngOnInit(): void {
    this.startCountdown();
  }

  ngOnDestroy(): void {
    clearInterval(this.interval);
  }

  startCountdown(): void {
    this.interval = setInterval(() => {
      if (this.countdown > 0) {
        this.countdown--;
      } else {
        this.dialogRef.close();
        clearInterval(this.interval);
      }
    }, 1000);
  }
}
